import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
axios.defaults.baseURL = apiBase.endsWith("/api/v3")
  ? apiBase
  : `${apiBase}/api/v3`;

const handleApi = async (url, method, data) => {
  // const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${token}`,
  };

  return axios({
    url,
    method,
    data,
    headers,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export default handleApi;
